const sortMasterFirst = (a,b) => a.type === 'master' ? -1 : b.type === 'master' ? 1 : 0;
const sortDefaultFirst = (a,b) => a.type === 'default' ? -1 : b.type === 'default' ? 1 : 0;

const sortNewestFirst = (a,b) => {
	return a.createTimeRaw > b.createTimeRaw ? -1 : a.createTimeRaw < b.createTimeRaw ? 1 : 0;
}

export {
	sortMasterFirst,
	sortDefaultFirst,
	sortNewestFirst,
}
